export default __webpack_public_path__ + "static/media/edit.6c008c59.svg";